import React from "react";
import CaseStudiesCard from "../../componets/CaseStudiesCard";
import CaseStudies from "../../data/caseStudies.json";
import { Link } from "react-router-dom";

const Section2 = () => {
  console.log(CaseStudies);
  return (
    <section className="w-[90%] lg:w-[85%] xl:w-[80%] h-auto pt-[200px] pb-[50px] md:pb-[50px] md:pt-[40px] flex flex-col gap-10 justify-evenly items-center m-auto ">
      <div>
        <h1 className="text-2xl font-bold text-red-600 md:text-4xl">
          Mean3 Case Studies
        </h1>
      </div>

      <div className="flex justify-center">
        <div className="grid w-full grid-cols-1 gap-10 m-auto md:grid-cols-2 lg:grid-cols-3">
          {CaseStudies.map((casesstudy, index) => (
            <Link to={`/case-study/${casesstudy.title}`}>
              <CaseStudiesCard
                key={index}
                image={casesstudy.image}
                title={casesstudy.title}
                text={casesstudy.description}
              />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Section2;
